export enum BUILD_VEHICLE_INPUTS {
  TITLE_FREE = 'freeTitle',
  BRAND = 'brand',
  BRAND_ALL = 'allBrand'
}

export enum OPERATION_VEHICLE {
  ALQUILER = 12,
  COMPRA = 13,
  VENTA = 14,
  ALQUILER_PEDIDO = 15,
  OFRECIDO = 16
}

export enum TYPE_VEHICLE {
  AUTOS = 1,
  PICKUPS = 2,
  MOTOCICLETAS = 3,
  CAMIONES_BUSES = 4,
  EMBARCACIONES = 5,
  MAQUINAS_MOTORES = 6,
  CAMIONETAS = 7,
  CAMIONES_BUSES_MAQ_PESADAS = 8,
  MOTOS_BICICLETAS_EMBARCACIONES = 9,
  ACCESORIOS_SERVICIOS = 10,
}

export const getInputsForTitle = (operation: number, typeVehicle: number) => {
  if ((
    TYPE_VEHICLE.AUTOS === typeVehicle ||
    TYPE_VEHICLE.PICKUPS === typeVehicle ||
    TYPE_VEHICLE.MOTOCICLETAS === typeVehicle ||
    TYPE_VEHICLE.CAMIONETAS === typeVehicle ||
    TYPE_VEHICLE.CAMIONES_BUSES === typeVehicle)
  && operation === OPERATION_VEHICLE.VENTA) {
    return BUILD_VEHICLE_INPUTS.BRAND_ALL;
  }
  if (TYPE_VEHICLE.MAQUINAS_MOTORES === typeVehicle) {
    return BUILD_VEHICLE_INPUTS.TITLE_FREE;
  }
  return BUILD_VEHICLE_INPUTS.BRAND;
};

export const isGetAllBrand = (typeVehicle: number) => {
  if (
    typeVehicle === TYPE_VEHICLE.EMBARCACIONES ||
    typeVehicle === TYPE_VEHICLE.MOTOS_BICICLETAS_EMBARCACIONES ||
    typeVehicle === TYPE_VEHICLE.ACCESORIOS_SERVICIOS
  ) {
    return true;
  }
  return false;
}
